import { styled } from "@mui/material";
import { StyledBaseLayout, StyledBaseMain } from "@/layouts/styles";

export const StyledContainer = styled(StyledBaseLayout)(({ theme }) => ({
  backgroundColor: theme.palette.primary.lighter,
}));

export const StyledMain = styled(StyledBaseMain)(({ theme }) => ({
  backgroundColor: theme.palette.primary.lighter,
  padding: "16px 120px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",

  [theme.breakpoints.down("desktop")]: {
    padding: "16px",
  },
}));
